import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../data/blogPosts';
import { createSlug } from '../../utils/slug';
import './BlogSection.css';

const BlogSection: React.FC = () => {
  const posts = blogPosts.slice(0, 4);

  return (
    <section className="blog-section">
      <div className="container">
        <div className="section-header">
          <p className="section-label">Mới về</p>
          <h2 className="section-title">BLOG</h2>
        </div>
        <div className="blog-grid">
          {posts.map((post) => (
            <article key={post.id} className="blog-card">
              <div className="blog-image">
                <img src={post.image} alt={post.title} />
              </div>
              <div className="blog-content">
                <Link to={`/blog/${createSlug(post.title)}`} className="blog-title-link">
                  <h3>{post.title}</h3>
                </Link>
                <div className="blog-meta">
                  <span>bởi {post.author}</span>
                  <span>{post.date}</span>
                  <span>{post.comments} bình luận</span>
                </div>
                <p>{post.excerpt}</p>
                <Link to={`/blog/${createSlug(post.title)}`} className="read-more">Đọc thêm</Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;

